import React, { useMemo } from "react";
import {useDataWithRoute} from "../utils/hooks";
import {useVsiAppContext} from "../stores/VsiApp";
import {VsiBubble} from "../styled/App.styled";
import ActivityGauge from "../components/ActivityGauge";
import Highcharts from "highcharts/highstock";
import {genericColors} from "../utils/chartUtils";
import styles from "../utils/themeStyles";
import {Col, Row, Spinner} from "reactstrap";

export default function BackupGapAnalysis(args) {

    const {theme} = useVsiAppContext();
    const basicTextStyle = useMemo(() => ({
        color: styles[theme].textColor,
        fontFamily: styles[theme].fontFamily,
    }), [theme]);

    const { client: { clientId }, getPeriodId } = useVsiAppContext();
    const periodId = getPeriodId("BACKUP");

    const route = useMemo(() => `/api/v6/report/backup_protection_gap_analysis_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId]);

    const [{ recordset: chartData}, { isLoading}] = useDataWithRoute(route);

    const chartConfig = useMemo(() => {
        const allSeries = [];
        const grouping = {};

        chartData.forEach(datum => {
            if (!grouping[datum.resource]) {
                grouping[datum.resource] = {};
            }

            Object.keys(datum).forEach(key => {
                if (typeof datum[key] === "number" && !key.endsWith("_id") && datum[key] !== 'resource') {
                    grouping[datum.resource][key] = (grouping?.[datum.resource]?.[key] ?? 0) + datum[key];
                }
            });
        });

        const groupKeys = Object.keys(grouping);

        const newData = groupKeys.map(key => {
            return {
                resource: key,
                total: grouping[key].total,
                protection_configured: grouping[key].protection_configured,
                incomplete: grouping[key].incomplete,
                successful: grouping[key].successful,
                unprotected: grouping[key].unprotected
            }
        });

        newData.forEach(datum => {
            let configTotlCheck = ((datum['protection_configured'] / datum['total']) || 0) * 100;
            if ((datum['protection_configured'] / datum['total']) === Infinity) {
                configTotlCheck = 0;
            }

            let firstGauge = configTotlCheck;
            let secondGauge = ((datum['successful'] / datum['protection_configured']) || 0) * 100;
            let thirdGauge = ((datum['incomplete'] / (datum['successful'] + datum['incomplete'])) || 0) * 100;
            if (firstGauge > 100) firstGauge = 100;
            if (secondGauge > 100) secondGauge = 100;
            if (thirdGauge > 100) thirdGauge = 100;

            let series = [{
                name: 'Protection Configured/Total',
                data: [{
                    color: genericColors[0],
                    radius: '112%',
                    innerRadius: '88%',
                    y: firstGauge
                }]
            }, {
                name: 'Protection Successful/Configured',
                data: [{
                    color: genericColors[1],
                    radius: '87%',
                    innerRadius: '63%',
                    y: secondGauge
                }]
            }, {
                name: 'Protection Failed/Unsuccessful',
                data: [{
                    color: genericColors[2],
                    radius: '62%',
                    innerRadius: '38%',
                    y: thirdGauge
                }]
            }];

            let resource = datum['resource']
            if (resource?.[0] === 'k') {
                resource = resource.slice(1);
            }


            allSeries.push([resource, series]);
        });
        return allSeries;
    }, [chartData]);

    return isLoading ? (
          <Spinner color={"success"}/>
          ) : (
                <div style={{height: "420px", overflowY: "scroll"}}>

                    <VsiBubble>
                        <Row className={"my-3 d-flex justify-content-center"}>
                            {chartConfig?.map(s => (
                                <Col xs={12} sm={12} md={2} style={{padding: 0, width: '250px'}}>
                                    <ActivityGauge title={s[0]} series={s[1]}/>
                                </Col>
                            ))}
                        </Row>
                        <Row className="justify-content-center">
                            <Col xs={12} sm={8} md={6}>
                                <table style={{padding: 0, margin: '0 auto'}}>
                                    <tr>
                                        <td width={25} height={10}
                                            style={{backgroundColor: genericColors[0], padding: 0}}>
                                        </td>
                                        <td width={25}
                                            style={{backgroundColor: Highcharts.color(genericColors[0]).setOpacity(0.3).get()}}></td>
                                        <td style={{
                                            color: basicTextStyle.color,
                                            fontSize: 10,
                                            marginLeft: 10,
                                            paddingLeft: 10,
                                        }}>Protection
                                            Configured / Total
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width={25} height={10}
                                            style={{backgroundColor: genericColors[1], padding: 0}}>
                                        </td>
                                        <td width={25}
                                            style={{backgroundColor: Highcharts.color(genericColors[1]).setOpacity(0.3).get()}}></td>
                                        <td style={{
                                            color: basicTextStyle.color,
                                            fontSize: 10,
                                            marginLeft: 10,
                                            paddingLeft: 10
                                        }}>Protection Successful / Configured
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width={25} height={10}
                                            style={{backgroundColor: genericColors[2], padding: 0}}>
                                        </td>
                                        <td width={25}
                                            style={{backgroundColor: Highcharts.color(genericColors[2]).setOpacity(0.3).get()}}></td>
                                        <td style={{
                                            color: basicTextStyle.color,
                                            fontSize: 10,
                                            marginLeft: 10,
                                            paddingLeft: 10
                                        }}>Protection Failed / Unsuccessful
                                        </td>
                                    </tr>
                                </table>
                            </Col>
                        </Row>
                    </VsiBubble>

                </div>
            )
}
